import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OneToOneChatComponent } from './one-to-one-chat/one-to-one-chat.component';
import { GroupChatComponent } from './group-chat/group-chat.component';
import { VideoCallsSharingComponent } from './video-calls-sharing/video-calls-sharing.component';
import { FileSharingComponent } from './file-sharing/file-sharing.component';
import { CalenderPageComponent } from './calender-page/calender-page.component';

const routes: Routes = [
    {path:'',component:OneToOneChatComponent},
    {path:'one-to-one-chat',component:OneToOneChatComponent},
    {path:'group-chat',component:GroupChatComponent},
    {path:'video-calls-sharing',component:VideoCallsSharingComponent},
    {path:'file-sharing',component:FileSharingComponent},
    {path:'calender-features',component:CalenderPageComponent},
];  

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CollaborationfeaturesRouting { } 